import { Account } from '@adtrackify/at-tracking-event-types';
import { Plus } from 'lucide-react';

import { AccountList } from './account-list';

import { Button } from '@/components/ui/button';
import { COMMAND_APPEARANCE } from '@/components/ui/types/command-variants-enums';
import { Command, CommandInput } from '@/components/ui/command';
import { CONTROL_SIZE } from '@/components/ui/types/control-enums';

interface TeamSwitcherContentProps {
  accounts: Account[];
  filteredAccounts: Account[];
  currentAccountId?: string;
  isLoading: boolean;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSelectAccount: (accountId: string) => void;
  onAddNewCompany: () => void;
  itemHeight: number;
}

export function TeamSwitcherContent({
  accounts,
  filteredAccounts,
  currentAccountId,
  isLoading,
  searchQuery,
  onSearchChange,
  onSelectAccount,
  onAddNewCompany,
  itemHeight,
}: TeamSwitcherContentProps) {
  const useVirtual = accounts.length > 100;
  const displayAccounts = useVirtual ? filteredAccounts : accounts;

  return (
    <>
      <Command appearance={COMMAND_APPEARANCE.DEFAULT} shouldFilter={accounts.length <= 100}>
        <CommandInput
          placeholder="Search workspaces..."
          value={searchQuery}
          onValueChange={onSearchChange}
          disabled={isLoading}
          size={CONTROL_SIZE.COMPACT}
        />
        <AccountList
          accounts={displayAccounts}
          currentAccountId={currentAccountId}
          isLoading={isLoading}
          useVirtual={useVirtual}
          itemHeight={itemHeight}
          onSelect={onSelectAccount}
        />
      </Command>
      <div className="border border-border bg-background p-2">
        <Button
          variant="ghost"
          className="w-full justify-start gap-2 border-border-default text-sm font-normal text-content-primary hover:bg-neutral-interaction-hover"
          disabled={isLoading}
          onClick={onAddNewCompany}
        >
          <Plus className="size-4" />
          Add a new workspace
        </Button>
      </div>
    </>
  );
}
